__turbopack_context__.v({
  "data": "OrganizerStats-module-scss-module__8F3W7q__data",
  "label": "OrganizerStats-module-scss-module__8F3W7q__label",
  "stat": "OrganizerStats-module-scss-module__8F3W7q__stat",
  "statWithDivider": "OrganizerStats-module-scss-module__8F3W7q__statWithDivider",
  "wrapper": "OrganizerStats-module-scss-module__8F3W7q__wrapper",
});
